// /import * as CONSTANTS from  './../constants.js';
import * as React from 'react';
import PropTypes from 'prop-types';
import xClass from 'utils/xClass';
import NavLink from 'ui-components/NavLink';
import {tooltipDecorator} from 'ui-components/ToolTip';
// var ART_DIRECTORY = CONSTANTS.ART_DIRECTORY;
import Work from 'types/Work';

const ART_DIRECTORY = "/images/art/";

export default class GridLink extends React.PureComponent{
	
	static propTypes = {
		piece: PropTypes.object,
		preload: PropTypes.bool
	};

	static defaultProps = {
		preload: false
	};

	componentWillReceiveProps(nextProps){
		let {preload} = this.props;
		if (nextProps.preload && !preload){
			this.preloadImage(nextProps.thumbnail);
		}
	}

	constructor(props){
		super(props);
		this.state = {};
		if (props.preload){
			this.preloadImage(props.src);
		}
	}

	preloadImage(src){
		// let img: HTMLImageElement = new Image();
		let img = new Image();
		img.onload = function(e){
			if (e){
				this.setState({image: e.target});
			}
		}.bind(this);
		
		img.src = ART_DIRECTORY + src;
	}

	getThumbStyle = (w) => {
		let src = ART_DIRECTORY + w.thumbnail;
		return {backgroundImage: `url(${src})`};
	}
	render(){
		let {
			piece,
			preload,
			...props
		} = this.props;
		return (
			<ThumbLink
				to={`/gallery/${piece.id}`}
				key={piece.id}
				id={`w_${piece.id}`}
				style={this.getThumbStyle(piece)}
				className={xClass(
					'grid-link-wrap',
					{'unloaded': preload && !this.state.image}
				)}
				{...props}
			/>
		);
	}

}



export class ThumbLink extends React.PureComponent{
	render(){
		let {
			to,
			title,
			id,
			className,
			style,
			...props
		} = this.props;
		return (
			<NavLink
				to={to}
				title={title}
				id={id}
				className={className}
			>
				<div
					className="grid-link"
					style={{
						position: "absolute",
						top: 0,
						left: 0,
						width: "100%",
						height: "100%",
						...style
					}}
					{...props}
				/>
			</NavLink>
		);
	}
}7